import { AxiosResponse } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export function requestSaveFnoActivationData(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.saveIncomeProof,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
export function requestSetuVerification(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.saveIncomeProof,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
export function requestSetuVerificationStatus(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'get',
    baseURL: endPoints.base,
    url: `${endPoints.verifyIncomeProofSetu}/${data.consentId}`,
  });
}
